module.exports = __webpack_public_path__ + "static/media/bodal1.ab02ad35.png";